import { VerifyDataCard } from '@/layouts/get-started/components'
import { AccountDetails } from '@/api/dashboard'
import { getCountries } from '@/translates'

interface VerifyAuthorizedSignatoryCardProps {
  data: AccountDetails
  onClickEdit?: () => void
}

const getCountryLabel = (key: string) => {
  const countries = getCountries()
  return (countries[key] || key) as string
}

export const VerifyAuthorizedSignatoryCard = ({ data, onClickEdit }: VerifyAuthorizedSignatoryCardProps) => (
  <VerifyDataCard
    title={[data.authorized_signatory?.first_name, data.authorized_signatory?.last_name].filter(Boolean).join(' ')}
    onClickEdit={onClickEdit}
  >
    <div className="overflow-hidden">
      <div className="mb-1.5 h-px" />
      <p className="mb-1.5 text-paragraph-sm">
        {[
          data.authorized_signatory?.country && getCountryLabel(data.authorized_signatory?.country),
          data.authorized_signatory?.job_title,
        ]
          .filter(Boolean)
          .join(', ')}
      </p>
      <p className="text-paragraph-sm">{data.authorized_signatory?.email}</p>
    </div>
  </VerifyDataCard>
)
